import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  GenericCrudComponent,
  IGenericCrudConfiguration
} from 'src/app/libs/components/generic-crud/generic-crud.component';
import {
  Bom,
  Product,
  Routing,
  DraftableStateTypes,
  TId,
  ProcessSheets,
  ProductionOrder,
  Equipment, EDraftableStateType,
} from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsProcessSheetsEditComponent } from './products-process-sheets-edit/products-process-sheets-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { ProductsProcessSheetsAddComponent } from './products-process-sheets-add/products-process-sheets-add.component';
import { ProcessSheetsResource } from 'src/app/resources';
import { AlertService } from 'src/app/services/alert.service';
import {ProductsAddComponent} from "../products-operative-products/products-add/products-add.component";
import {ProductsEditComponent} from "../products-operative-products/products-edit/products-edit.component";
import {
  ProductPricesComponent
} from "../products-operative-products/components/product-prices/product-prices.component";
import {ProductStockComponent} from "../products-operative-products/components/product-stock/product-stock.component";
import {
  ProductSubscribersComponent
} from "../products-operative-products/components/product-subscribers/product-subscribers.component";
import {AclService} from "../../../../libs/services/acl.service";
import {
  ProductProcesSheetsComponent
} from "../products-operative-products/product-proces-sheets/product-proces-sheets.component";
import {
  ProductSimulationsComponent
} from "../products-operative-products/product-simulations/product-simulations.component";

@Component({
    selector: 'app-products-process-sheets',
    templateUrl: './products-process-sheets.component.html',
    styleUrls: ['./products-process-sheets.component.sass'],
    standalone: false
})
export class ProductsProcessSheetsComponent implements OnInit {
  config?: IGenericCrudConfiguration<ProcessSheets>;
  @ViewChild ('crud') dataGrid?: GenericCrudComponent<Equipment>;
  selectedProcessSheet?: ProcessSheets;
  isSetActiveEnabled = false;



  constructor(private api: MasterApiService, private acl: AclService, private translateService: TranslateService, private alertService: AlertService) {}

   async ngOnInit(): Promise<void> {
    const stateTypes = DraftableStateTypes.map(x => ({ id: x.id, name: this.translateService.instant(`enumeration.DraftableStateTypes.${x.name}`) }));

    this.config = {
      name: this.api.resources.product.processSheets.resourceName,
      resource: this.api.resources.product.processSheets,
      createComponent: ProductsProcessSheetsAddComponent,
      editComponent: ProductsProcessSheetsEditComponent,
      entityId: 'id',
      entityFields: {
        code: { isLink: true, dataType: 'code'},
        name: {isLink: true, dataType: 'shortstring'},
        version: { caption: 'entity.processSheet.version', dataType: 'code'},
        documentTypeName: { caption: 'entity.project.documentTypeId', dataType: 'shortstring'},
        product: { caption: 'entity.product.product', dataType: 'shortstring', calculateCellValue: (rowData: ProcessSheets) => {
            return rowData.productCode + ' ' + (rowData.productName || '');
          },  isLink: true,
          editor: {
            component: ProductsEditComponent,
            inputPrms: async (row) => {
              const innerEditors: any[] = []
              innerEditors.push({
                name: 'price',
                component: ProductPricesComponent,
                inputPrms: { id: row.productId }
              })
              innerEditors.push({
                name: 'stock',
                component: ProductStockComponent,
                inputPrms: { id: row.productId }
              })
              innerEditors.push({
                name:'processsheets',
                component: ProductProcesSheetsComponent,
                inputPrms: { productId: row.productId }
              })
              innerEditors.push({
                name:'simulations',
                component: ProductSimulationsComponent,
                inputPrms: { id: row }
              })
              if (this.acl.isAdmin()) {
                innerEditors.push({
                  name: 'subscribers',
                  component: ProductSubscribersComponent,
                  inputPrms: { id: row.productId },
                  isAdminConfig: true
                });
              }
              return {
                id: row.productId,
                innerEditors: innerEditors,
              };
            }
          }},
        route: { caption: 'entity.asset.breadcrumb', dataType: 'shortstring', calculateCellValue: (rowData: ProcessSheets) => {
            return rowData.routingName + ' ' + (rowData.routingVersion || '');
          } },
        materialList: { caption: 'entity.processSheet.materialList', dataType: 'shortstring', calculateCellValue: (rowData: ProcessSheets) => {
            return rowData.bomName + ' ' + (rowData.bomVersion || '');
          } },
        revisionStateId: { caption: 'common.state', dataType: 'number',
          lookup: {
            dataSource: stateTypes,
            displayExpr: 'name',
            valueExpr: 'id',
          },
          cellTemplate: 'stateCellTpl',
        },
        isMainProcessSheet:{caption: 'common.main'}

      },
      stateField: 'revisionStateId',
      multiOptionButtons: [
        {
          icon: 'forms_add_on',
          hint: 'entity.product.newVersion',
          visible: true,
          disabled: 'this.selection.length !== 1',
          options: [
            { text: 'entity.processSheet.newVersion', icon:'graph_1', action: async (e) => this.newVersion(e) },
            { text: 'entity.processSheet.newRevision', icon:'graph_1', action: async (e) => this.newRevision(e) },
            // { text: 'Copiar el process sheet', action: async (e) => this.actionOption3(e) },
          ],
        },
      ],
      genericButtons: [
        {
          icon: 'bookmark_added',
          hint: 'common.main',
          visible: true,
          disabled: () => !this.isSetActiveEnabled,
          clickFunction: async () => {
            await this.setActive();
          }
        }
      ],
      changeStateAction: (e) => this.changeState(e),
      crudButtons: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canCopy: true,
      },
      customDeleteFunction: (this.api.resources.product.processSheets as unknown as ProcessSheetsResource).deleteRevision.bind(
        this.api.resources.product.processSheets
      ),

    }

   }
   async changeState(e: {element: ProcessSheets, destinationStateId: number}) : Promise<void> {
    if ('revisionStateId' in e.element){
      // if(e.element.revisionStateId !== 1){
      //   this.alertService.alert('entity.processSheets.cannotChangeState');
      //   return;
      // }
      const resource = this.api.resources.product.processSheets as unknown as ProcessSheetsResource;
      const rs = await firstValueFrom(resource.customChangeState(e.element, e.destinationStateId)) as ProcessSheets;
      e.element.revisionStateId = rs.revisionStateId;
      e.element.stateId = rs.stateId;
      e.element = rs;
    }
  }


   private async newVersion(e: ProcessSheets): Promise<void> {
    const selectedId = e.processSheetId;
    const versionId =  e.versionId;
    const revisionId = e.revisionId;
    await firstValueFrom((this.api.resources.product.processSheets as unknown as ProcessSheetsResource).newversion(selectedId, versionId, revisionId));
    await  this.dataGrid?.refreshData()
    this.alertService.success('entity.processSheet.newVersionSuccess')
  }

  private async newRevision(e: ProcessSheets): Promise<void> {
    const selectedId = e.processSheetId;
    const versionId =  e.versionId;
    const revisionId = e.revisionId;
    await firstValueFrom((this.api.resources.product.processSheets as unknown as ProcessSheetsResource).newrevision(selectedId, versionId, revisionId));
    await  this.dataGrid?.refreshData()
    this.alertService.success('entity.processSheet.newRevisionSuccess')
  }

  async onSelectionChanged() {
    this.isSetActiveEnabled = false;
    this.selectedProcessSheet = undefined;

    const selected = this.dataGrid?.getDataElementsFromSelection() ?? [];

    if (selected.length !== 1) {
      return;
    }

    this.selectedProcessSheet = selected[0] as ProcessSheets;

    this.isSetActiveEnabled =
      !this.selectedProcessSheet.isMainProcessSheet &&
      (
        this.selectedProcessSheet.revisionStateId === EDraftableStateType.Draft ||
        this.selectedProcessSheet.revisionStateId === EDraftableStateType.Active
      );
  }
  async setActive() {
    if (!this.selectedProcessSheet) {
      return;
    }

    await firstValueFrom(
      this.api.resources.product.products.patch(
        this.selectedProcessSheet.productId,
        {
          action: 'setProcessSheetRevision',
          processSheetId: this.selectedProcessSheet.processSheetId,
          processSheetVersionId: this.selectedProcessSheet.versionId,
          processSheetRevisionId: this.selectedProcessSheet.revisionId,
        }
      )
    );

    await this.dataGrid?.refreshData();

  }

}
